import {
  TicketType,
  Tournament,
  TournamentPayoutBracketSnapshot,
  TournamentStatus,
  TournamentTemplate,
} from '@repo/database/src/types';

import { PlayerStats } from './event-types';

export type TournamentState = {
  playersStats: Record<string, PlayerStats>;
  leaderboard: PlayerStats[];
  averageStack: number;
  biggestStack: number;
  smallestStack: number;
  playersRemaining: number;
  entries: number;
  bubblePosition: number;
  payoutBrackets: TournamentPayoutBracketSnapshot[];
  parentBuyIn: number | null;
  prizePool: number;
};

export const preStartedStatuses: TournamentStatus[] = [TournamentStatus.CREATED, TournamentStatus.INITIALIZING];
export const sngRegistrationOpenStatuses: TournamentStatus[] = [TournamentStatus.CREATED];
export const activeTournamentStatuses: TournamentStatus[] = [
  TournamentStatus.INITIALIZING,
  TournamentStatus.RUNNING,
  TournamentStatus.BREAK,
  TournamentStatus.PAUSED,
  TournamentStatus.RESTARTING,
];
export const nonActiveTournamentStatuses: TournamentStatus[] = [TournamentStatus.CANCELLED, TournamentStatus.COMPLETED];

export const playingStatuses: TournamentStatus[] = [
  TournamentStatus.RUNNING,
  TournamentStatus.BREAK,
  TournamentStatus.PAUSED,
  TournamentStatus.RESTARTING,
];

export interface TournamentWComputed extends Tournament {
  totalBuyin: number;
}

export interface TournamentTemplateWComputed extends TournamentTemplate {
  totalBuyin: number;
}

export interface SatelliteTournamentWinner {
  userId: string;
  prizeType: TicketType;
  amount: number;
  parentTournamentId: string | null;
  isTournamentDollars: boolean;
}
